export const EXCLUDED_DOCTYPES_DEFAULT = ['ANALYSIS_DOCUMENT', 'TRACKER', 'BIG5', 'COUNTRY_PROFILE', 'OVERVIEW_DOC','BIG5_SECTION','CJEU_CASE'];
export const EXCLUDED_DOCTYPES_BY_PILLAR =['PUBLICATION_ANALYSIS_DOCUMENT', 'PUBLICATION_TRACKER', 'BIG5', 'COUNTRY_PROFILE', 'OVERVIEW_DOC','BIG5_SECTION','CJEU_CASE'];
export const EXCLUDED_DOCTYPES_BY_DOCTYPE=['BIG5_SECTION'];

export const EXCLUDED_DOCTYPES_SEARCH = ['PUBLICATION_ANALYSIS_DOCUMENT', 'PUBLICATION_BIG5','BIG5','PUBLICATION_TRACKER','REGION_PROFILE'];
export const ITEMS_PER_PAGE = 25;

export class SearchInput{
    query?: string;
    page?: number;
    limit?: number;
    sortCriteria?: string;
    region?: string;
    pillar?: string;
    service?: string;
    publishingYear?: string;
    documentType?: string;
    authority?: string;
    searchType?: string;
    fromPublicationDate?: string;
    toPublicationDate?: string;
    keyword?: string;
    country?: string;
    rejectedDocumentTypes?: string[];
    publishingStatus?:string;

    
    constructor(params: SearchInput = {} as SearchInput) {

        const {
            query = "",
            page = 0,
            limit = ITEMS_PER_PAGE,
            sortCriteria = 'RELEVANCE',
            region = "",
            pillar = "",
            service = "",
            publishingYear = "",
            documentType = "",
            authority = "",
            searchType = null,
            fromPublicationDate = "",
            toPublicationDate= "",
            keyword= "",
            country= "",
            rejectedDocumentTypes = EXCLUDED_DOCTYPES_DEFAULT,
            publishingStatus=null
        } = params;

        this.query=query;
        this.page=page;
        this.limit=limit;
        this.sortCriteria=sortCriteria;
        this.region=region;
        this.pillar=pillar;
        this.service=service;
        this.publishingYear=publishingYear;
        this.documentType=documentType;
        this.authority=authority;
        this.searchType=searchType;
        this.fromPublicationDate=fromPublicationDate;
        this.toPublicationDate=toPublicationDate;
        this.keyword=keyword;
        this.country=country;
        this.rejectedDocumentTypes=rejectedDocumentTypes;
        this.publishingStatus=publishingStatus;
    }
}